import { useBenefit } from "../../benefits/hooks/useBenefits";
import { EBenefitTypes, EShowMode } from "../../benefits/enums/benefits.enums";
import { AccessDecision } from "../AccessGate.types";

/**
 * Strategy hook that checks a plan-based benefit entitlement.
 *
 * Wraps the existing `useBenefit` hook and maps its output to a
 * generic `AccessDecision` so it can be consumed by `<AccessGate>`.
 *
 * @example
 * const access = useBenefitStrategy(EBenefitTypes.METRICS_ADVANCED);
 * <AccessGate strategy={access} behavior={OverlayBehavior}>…</AccessGate>
 */
export function useBenefitStrategy(benefit: EBenefitTypes): AccessDecision {
    const { decision, entitlement } = useBenefit(benefit);

    return {
        granted: decision.mode === EShowMode.ENABLED,
        reason: decision.reason,
        meta: { entitlement, mode: decision.mode },
    };
}
